import { getImageUrl as getImageUrlByEnvironment } from '../utils/urls'
import { useSiteContext } from './use-site-context'

export type ImageUrlProps = {
  imageFilename: string | null | undefined
  xSize?: number
  ySize?: number
  textToCreateSlugFrom?: string
}

export const useImageUrl = () => {
  const { serverEnv } = useSiteContext()

  const getImageUrl = (props: ImageUrlProps) => {
    return getImageUrlByEnvironment({ ...props, environment: serverEnv })
  }

  return {
    getImageUrl,
  }
}
